var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-group-item",on:{"click":_vm.beforeViewDetail}},[_c('h2',{staticClass:"m-text-cut"},[_vm._v(_vm._s(_vm.group.name))]),(_vm.choose)?_c('svg',{staticClass:"m-style-svg m-svg-def"},[_c('use',{attrs:{"xlink:href":"#icon-qs_focused"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }